import i18n from 'i18next';
import { pickLang } from '@zsp/shared';

type SpecialistNameShape =
  | {
      displayName?: unknown;
      user?: { name?: string | null; email?: string | null } | null;
    }
  | null
  | undefined;

/** Patient-facing display name for a specialist, matching what the voice bot
 *  uses: the localized `displayName`, then the account name, then email.
 *  `lang` defaults to the active UI language. Requires `displayName` + `user`
 *  to be included on the queried specialist. */
export function specialistName(s: SpecialistNameShape, lang?: string): string {
  const l = lang ?? i18n.language;
  return pickLang(s?.displayName, l) || s?.user?.name || s?.user?.email || '—';
}
